// Registra um controller só quando aparece na página um elemento que o usa. Cada import() vira
// um chunk à parte no build (esbuild.config.mjs): quem lê uma notícia não baixa o editor de
// texto, o de imagem nem os gráficos do admin.
//
// `loaders` mapeia identifier → () => import("./x_controller"). Depois de registrado, o Stimulus
// conecta os elementos que já estão na página e os que chegarem depois (navegação do Turbo).
export function lazyLoadControllers(application, loaders) {
  const pending = new Map(Object.entries(loaders))
  const attribute = application.schema.controllerAttribute

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes") {
        loadWithin(mutation.target)
      } else {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) loadWithin(node)
        }
      }
    }
  })

  function loadWithin(element) {
    for (const [identifier, loader] of pending) {
      const selector = `[${attribute}~="${identifier}"]`
      if (!element.matches(selector) && !element.querySelector(selector)) continue

      pending.delete(identifier)
      loader()
        .then((module) => application.register(identifier, module.default))
        .catch((error) => console.error(`Falha ao carregar o controller "${identifier}"`, error))
    }

    if (pending.size === 0) observer.disconnect()
  }

  observer.observe(document.documentElement, {
    attributeFilter: [attribute],
    childList: true,
    subtree: true,
  })
  loadWithin(document.documentElement)
}
